import React from "react";
import { Text, Flex } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { SPACING } from "#utils/spacing";
import * as styles from "../../styles_vanilla.css";

type DocumentDetailsRowProps = {
  documentName?: string;
};

const DocumentDetailsRow = ({ documentName }: DocumentDetailsRowProps) => {
  return (
    <Flex alignItems="center" gap={SPACING.MEDIUM}>
      <div className={styles.documentIcon}>
        <Icon color={Colors.Neutral600} type="file-alt" size="large" variant="solid" />
      </div>
      <Text data-testid="document-name">{documentName}</Text>
    </Flex>
  );
};

export default DocumentDetailsRow;
